import React from "react";
import UserHeader from "./UserHeader";

interface Props {
  selectedUserData: any;
  isHistoryPage: boolean;
  setActivePhone: (p: string) => void;
  setViewingNotifications: (v: boolean) => void;
  setIsHistoryPage: (v: boolean) => void;
  conversationCounts: Record<string, number>;
  activeNotification: any;
  selectedConversationLastDate: string | null;
}

const UserHeaderSection: React.FC<Props> = ({
  selectedUserData,
  isHistoryPage,
  setActivePhone,
  setViewingNotifications,
  setIsHistoryPage,
  conversationCounts,
  activeNotification,
  selectedConversationLastDate,
}) => (
  <div className="flex justify-between items-start px-6 py-4 border-b border-gray-200">
    <div className="flex w-full justify-between gap-1">
      <div className="flex items-center gap-2 w-full">
        <UserHeader
          user={selectedUserData}
          isHistoryPage={isHistoryPage}
          onHistoryClick={(phone: any) => {
            setActivePhone(phone);
            setViewingNotifications(false);
            setIsHistoryPage(true);
          }}
          conversationCounts={conversationCounts}
          lastMessageDate={
            isHistoryPage ? selectedConversationLastDate : activeNotification?.date
          }
        />
      </div>
    </div>
  </div>
);

export default UserHeaderSection;
